<template>
  <ul id="navigation">
    <li v-for="itm in list" :key="itm.node_id" class="pt-1 pl-2 pr-2 text-subtitle-1">
      <div @click="itemClick(itm)" class="pl-1" :class="{'white--text':theme=='dark', 'black--text':theme!='dark', 'active-item': itm.active, 'root-item': itm.node_id == 'root_node'}">
        <v-icon x-small :color="theme=='dark' ? 'white' : 'black'" v-if="itm.children && itm.children.length && itm.node_id != 'root_node'">{{itm.open ? 'mdi-minus' : 'mdi-plus'}}</v-icon>
        <v-icon x-small :color="theme=='dark' ? 'white' : 'black'" v-else>{{itm.icon}}</v-icon>
        {{ itm.label }} <span class="blue--text text--black" v-if="Number(itm.badge) > 0">(+{{itm.badge}})</span>
      </div>
      <nav-dropdown-panel v-if="itm.children && itm.children.length" :list="itm" :theme="theme" :on-item-click="itemClick"/>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'uiNavList',
  props: ['list', 'onItemClick', 'theme'],
  components: {
    NavDropdownPanel: () => import(/* webpackChunkName: "sysCommon" */'@/components/common/ui/lists/navMultilevel/nav-dropdown-panel.vue')
  },
  watch: {
    list (val) {
      console.log('uiNavList list changed ', val)
    }
  },
  methods: {
    deactivateAll (list) {
      list.forEach(item => {
        item.active = false
        if (!item.children) return
        item.children.map(itm => {
          itm.active = false
          if (itm.children) this.deactivateAll(itm.children)
        }, this)
      }, this)
    },
    itemClick (item) {
      this.deactivateAll(this.list)
      item.active = !item.active
      if (item.children && item.children.length) item.open = !item.open
      if (typeof this.onItemClick === 'function') {
        this.onItemClick(item)
      }
    }
  },
  mounted () {
    console.log('uiNavList mounted with list ', this.list)
  }
}
</script>

<style scoped>
  #navigation {
    list-style: none;
  }
  #navigation li {
    position: relative;
    cursor: pointer;
  }
  #navigation li i {
    position: absolute;
    top: 12px;
    right: 10px;
  }
  .active-item {
    font-weight: bolder;
  }
  .root-item {
    border: 1px solid #990000;
  }
</style>
